import React from 'react';
import {
  ApiButton,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from 'web-library';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MutationStatus } from 'react-query';
import { Theme as AugmentedTheme } from '@mui/material/styles';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  buttonContainer: {
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  statementOne: {
    marginBottom: theme.spacing(3),
  },
}));

interface BankTransferModalProps {
  modelOpen: boolean;
  onClose: () => void;
  onClickCheckout: () => void;
  statusPaymentOffline: MutationStatus;
}

const BankTransferModal = ({
  modelOpen,
  onClose,
  onClickCheckout,
  statusPaymentOffline,
}: BankTransferModalProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Dialog open={modelOpen} maxWidth="md">
      <DialogTitle> {t('components->>Payment.BankTransfer')}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          <Typography className={classes.statementOne} variant="body1">
            {t('components->>Payment.BankTransferStatementOne')}
          </Typography>
          <Typography variant="body1">
            {t('components->>Payment.BankTransferStatementTwoPartOne')}
          </Typography>
          <Typography variant="body1">
            {t('components->>Payment.BankTransferStatementTwoPartTwo')}
          </Typography>
          <Typography variant="body1">
            {t('components->>Payment.BankTransferStatementTwoPartThree')}
          </Typography>
          <Typography variant="body1">
            {t('components->>Payment.BankTransferStatementTwoPartFour')}
          </Typography>
          <Typography variant="body1">
            {t('components->>Payment.BankTransferStatementTwoPartFive')}
          </Typography>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Box className={classes.buttonContainer}>
          <Button type="button" variant="text" onClick={onClose}>
            {t('components->>Payment.Cancel')}
          </Button>
          <ApiButton
            id="button-bankTransferModal-proceedBankTransfer"
            type="button"
            status={statusPaymentOffline}
            onClick={onClickCheckout}
          >
            {t('components->>Payment.ProceedWithBankTransfer')}
          </ApiButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default BankTransferModal;
